import React from 'react';
import { Twitter, Facebook, Copy, Check } from 'lucide-react';
import './SocialMedia.css';

const SocialMedia: React.FC = () => {
  const [copied, setCopied] = React.useState(false);

  const socialLinks = {
    linkedin: 'https://www.linkedin.com/company/namibia-mining-and-energy/',
    twitter: 'https://x.com/miningandenergy',
    facebook: 'https://www.facebook.com/MiningandEnergyNA'
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.log('Error copying link:', error);
    }
  };

  return (
    <div className="social-media">
      <a 
        href={socialLinks.linkedin}
        target="_blank"
        rel="noopener noreferrer"
        className="social-button"
        title="Follow us on LinkedIn"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
      </a>
      
      <a 
        href={socialLinks.twitter}
        target="_blank"
        rel="noopener noreferrer"
        className="social-button"
        title="Follow us on X (Twitter)"
      >
        <Twitter size={16} />
      </a>
      
      <a 
        href={socialLinks.facebook}
        target="_blank"
        rel="noopener noreferrer"
        className="social-button"
        title="Follow us on Facebook"
      >
        <Facebook size={16} />
      </a>
      
      <button 
        className="social-button"
        onClick={handleCopyLink}
        title="Copy link"
      >
        {copied ? <Check size={16} /> : <Copy size={16} />}
      </button>
    </div>
  );
};

export default SocialMedia; 